// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent-user {
  display: flex;
  justify-content: end;
}

.item-user {
  display: flex;
  direction: rtl;
}

.item-right {
  margin-right: 20px;
  margin-left: 20px;
  margin-right: 25px;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: small;
  color: blue;
}

.item-left {
  margin-right: 20px;
  margin-left: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: small;
}

.table-servicePayment {
  width: 100%;
  direction: rtl;
}

th {
  text-align: right;
  color: blue;
}

td {
  text-align: right;
  font-family: IRANSans;
}

.header-servicePayment {
  direction: rtl;
  font-size: smaller;
  margin-right: 20px;
}

.card-serviceInstallment {
  margin-top: 4rem;
  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;
}

.card-servicePayment {
  margin-top: 4rem;
  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;
}

.span-text {
  color: blue;
}

.sentence-payment {
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 2rem;
}

.card-sentence {
  height: 4rem;
  margin-top: 4rem;
  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;
}

.btn-back {
  margin-top: 20px;
  margin-left: 20px;
  margin-bottom: 20px;
}

.parent-both {
  display: flex;
  margin: auto;
  padding: 20px;
}

.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

h1 {
  font-size: larger;
}`, "",{"version":3,"sources":["webpack://./src/app/features/services/services-payment/services-payment.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/services/services-payment/services-payment.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,oBAAA;ACCJ;;ADCA;EACI,aAAA;EACA,cAAA;ACEJ;;ADCA;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;ACEJ;;ADCA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ACEJ;;ADAA;EACI,WAAA;EACA,cAAA;ACGJ;;ADDE;EACE,iBAAA;EACA,WAAA;ACIJ;;ADFE;EACE,iBAAA;EACA,qBAAA;ACKJ;;ADHE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;ACMJ;;ADJE;EACE,gBAAA;EACA,uGAAA;ACOJ;;ADLE;EACE,gBAAA;EACA,uGAAA;ACQJ;;ADNE;EACE,WAAA;ACSJ;;ADPE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;ACUJ;;ADRE;EACE,YAAA;EACA,gBAAA;EACA,uGAAA;ACWJ;;ADTE;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;ACYJ;;ADVE;EACE,aAAA;EACA,YAAA;EACA,aAAA;ACaJ;;ADVA;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACaJ;;ADVA;EACI,iBAAA;ACaJ","sourcesContent":[".parent-user{\r\n    display: flex;\r\n    justify-content: end;\r\n}\r\n.item-user{\r\n    display: flex;\r\n    direction: rtl;\r\n    \r\n}\r\n.item-right{\r\n    margin-right: 20px;\r\n    margin-left: 20px;\r\n    margin-right: 25px;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n    font-size: small;\r\n    color: blue;\r\n}\r\n\r\n.item-left{\r\n    margin-right: 20px;\r\n    margin-left: 20px;\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n    font-size: small;\r\n}\r\n.table-servicePayment {\r\n    width: 100%;\r\n    direction: rtl;\r\n  }\r\n  th{\r\n    text-align: right;\r\n    color: blue;\r\n  }\r\n  td{\r\n    text-align: right;\r\n    font-family: IRANSans;\r\n  }\r\n  .header-servicePayment{\r\n    direction: rtl;\r\n    font-size: smaller;\r\n    margin-right: 20px;\r\n  }\r\n  .card-serviceInstallment{\r\n    margin-top: 4rem;\r\n    box-shadow: rgb(103 103 103 / 35%) -4px 0px 20px 2px, rgb(255 255 255 / 40%) -20px -1px 60px -30px;\r\n  }\r\n  .card-servicePayment{\r\n    margin-top: 4rem;\r\n    box-shadow: rgb(103 103 103 / 35%) -4px 0px 20px 2px, rgb(255 255 255 / 40%) -20px -1px 60px -30px;\r\n  }\r\n  .span-text{\r\n    color: blue;\r\n  }\r\n  .sentence-payment{\r\n    text-align: center;\r\n    margin-top: 1rem;\r\n    margin-bottom: 2rem;\r\n  }\r\n  .card-sentence{\r\n    height: 4rem;\r\n    margin-top: 4rem;\r\n    box-shadow: rgb(103 103 103 / 35%) -4px 0px 20px 2px, rgb(255 255 255 / 40%) -20px -1px 60px -30px;\r\n  }\r\n  .btn-back{\r\n    margin-top: 20px;\r\n    margin-left: 20px;\r\n    margin-bottom: 20px;\r\n  }\r\n  .parent-both {\r\n    display: flex;\r\n    margin: auto;\r\n    padding: 20px;\r\n}\r\n\r\n.title {\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\nh1 {\r\n    font-size: larger;\r\n}",".parent-user {\n  display: flex;\n  justify-content: end;\n}\n\n.item-user {\n  display: flex;\n  direction: rtl;\n}\n\n.item-right {\n  margin-right: 20px;\n  margin-left: 20px;\n  margin-right: 25px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  font-size: small;\n  color: blue;\n}\n\n.item-left {\n  margin-right: 20px;\n  margin-left: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  font-size: small;\n}\n\n.table-servicePayment {\n  width: 100%;\n  direction: rtl;\n}\n\nth {\n  text-align: right;\n  color: blue;\n}\n\ntd {\n  text-align: right;\n  font-family: IRANSans;\n}\n\n.header-servicePayment {\n  direction: rtl;\n  font-size: smaller;\n  margin-right: 20px;\n}\n\n.card-serviceInstallment {\n  margin-top: 4rem;\n  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;\n}\n\n.card-servicePayment {\n  margin-top: 4rem;\n  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;\n}\n\n.span-text {\n  color: blue;\n}\n\n.sentence-payment {\n  text-align: center;\n  margin-top: 1rem;\n  margin-bottom: 2rem;\n}\n\n.card-sentence {\n  height: 4rem;\n  margin-top: 4rem;\n  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;\n}\n\n.btn-back {\n  margin-top: 20px;\n  margin-left: 20px;\n  margin-bottom: 20px;\n}\n\n.parent-both {\n  display: flex;\n  margin: auto;\n  padding: 20px;\n}\n\n.title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nh1 {\n  font-size: larger;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
